
import { put, call, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit } from 'redux-form'
import moment from 'moment'
import _ from 'lodash'

import * as actions from '../actions/kenmeiList'

function* handleInit(action) {
  yield put(actions.reducerInit())
}

export function* root() {
  yield takeEvery(actions.SYSTEM_INIT, handleInit);
}


// WEBPACK FOOTER //
// ./src/sagas/kenmeiList.js